/**
 * Change provided set of anchors from relative to static for pages not hosted on www
 * @returns {canonicalUrl} string
 */
export default function makeLinksStatic(links, domain, subdomain) {
  links.forEach(link => {
    const linkHref = link.getAttribute('href');
    if (!linkHref.startsWith('http')) {
      if (link.pathname !== '/') {
        const linkElement = link;
        let targetSubdomain = 'www';
        if (subdomain.endsWith('eu')) {
          targetSubdomain = 'eu';
        }
        linkElement.href = `https://${targetSubdomain}.${domain}.com${linkHref}`;
      }
    }
  });
}
